"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeTokenType = void 0;
var TradeTokenType;
(function (TradeTokenType) {
    /** 机器人账户token */
    TradeTokenType["spot"] = "spot";
    /** 币安合约token */
    TradeTokenType["swap"] = "swap";
    /** 交易员账户token (包含合约和现货) */
    TradeTokenType["trader"] = "trader";
})(TradeTokenType || (exports.TradeTokenType = TradeTokenType = {}));
